export enum Screens {
  DASHBOARD = '/dashboard',
  //Admin Screens
  ADMIN = '/admin',
  USER_ADMIN = '/admin/user-admin',
  LOCATION_ADMIN = '/admin/location-admin',
  LOCATION_GROUP = '/admin/location-group',
  ADMIN_SEARCH = '/admin/admin-search',
  DEVICE_ADMIN = '/admin/device-admin',
  MAINTENANCE = '/admin/maintenance',
  ///
  //Arrive Depart
  ARRIVE_DEPART = '/arrive-depart',
  ARRIVE = '/arrive-depart/arrive',
  DEPART = '/arrive-depart/depart',
  ///
  //Revenue Recovery
  REVENUE_RECOVERY = '/revenue-recovery',
  ADDITIONAL_HANDLING = '/revenue-recovery/additional-handling',
  SIZE_AUDIT = '/revenue-recovery/size-audit',
  WEIGHT_AUDIT = '/revenue-recovery/weight-audit',
  WWEF = '/revenue-recovery/world-wide-express-freight',
  ///
  //INBOUND
  INBOUND = '/inbound',
  INBOUND_SCAN = '/inbound/inbound-scan',
  ENHANCED_INBOUND_SCAN = '/inbound/enhanced-inbound-scan',
  WAREHOUSE_OUTBOUND = '/inbound/warehouse-outbound',
  WAREHOUSE_SCAN = '/inbound/warehouse-scan',
  INBOUND_PACKAGE_STATUS = '/inbound/inbound-package-status',
  CROSS_REFERENCE = '/inbound/cross-reference',
  ///
  //POSITION-OPERATIONS
  OPERATIONS = '/position-operations',
  OUTBOUND_SCAN = '/position-operations/outbound-scan-gle',
  END_OUTBOUND_SCAN = '/position-operations/end-outbound-scan-gle',
  CLEAR_SECURITY_SCAN = '/position-operations/clear-security-screening',
  INTERCEPTS = '/position-operations/intercept-summary',
  ACTIVE_CARRY_OVER_LOADS = '/position-operations/active-carry-over-loads',
  OUTBOUND_PACKAGE_STATUS = '/position-operations/outbound-package-status',
  //CUSTOMER
  CUSTOMER = '/customer',
  LOAD_TRANSFER = '/customer/load-transfer',
  REPROCESS_EDI = '/customer/reprocess-edi',
  REPROCESS_CVIS = '/customer/reprocess-cvis',
  ///
  //SCI
  SCI = '/sci',
  SHIPPER_CONFIG = '/sci/shipper-config',
  EDI_SWAP = '/sci/edi-swap',
  CVIS_SWAP = '/sci/cvis-swap',
  ///
  MESSAGES = '/messaging',
  REPORTS = '/reports',
  LOGOUT = '/logout',
  //Not Technically a Screen but including here anyway for role permissions://
  TRACKINGNUMBERSEARCH = '/trackingnumbersearch',
  ///////
}

export enum Reports {
  //Position Based//
  OUTBOUND_EXTRACT,
  OUTBOUND_SCAN,
  MANIFEST,
  ULD_EXTRACT,
  //////////////////////
  //Inventory//
  LOCATION_INVENTORY,
  GROUP_INVENTORY,
  //////////////////////
  //Errors//
  LOCATION_ERROR,
  GROUP_ERROR,
  //////////////////////
  //EDI//
  EDI_REPORT,
  EDI_GROUP_REPORT,
  EDI_ERROR_REPORT,
  EDI_GROUP_ERROR_REPORT,
  //////////////////////
  //Revenue Recovery//
  REVENUE_RECOVERY_AUDIT,
  //////////////////////
  //Inbound//
  INBOUND_EXTRACT,
  WAREHOUSE_SCAN,
  //////////////////////
  //Other//
  EXCEPTIONS_SCANS,
  HEAVYGOODS_FORECAST,
  BUILDING_SNAPSHOT,
  //////////////////////
  //SCI//
  SCI_REPORT,
  SCI_ERROR,
  //////////////////////
}

export enum ReportCluster {
  POSTION_BASED,
  INVENTORY,
  ERRORS,
  EDI,
  REVENUE_RECOVERY,
  INBOUND,
  OTHER,
  SCI,
}
